/** @jsx jsx */
import { forwardRef, type ReactNode, type Ref } from 'react';

import { cssMap, jsx } from '@compiled/react';

export const MenuList = forwardRef<HTMLUListElement, MenuListProps>(_MenuList);

// Placing this const below the function breaks Compiled!
const styles = cssMap({
	root: {
		margin: '0',
		padding: '0',
	},
});

function _MenuList({ children }: MenuListProps, ref: Ref<HTMLUListElement>) {
	return (
		<ul css={styles.root} ref={ref}>
			{children}
		</ul>
	);
}

type MenuListProps = {
	children: ReactNode;
};
